<template>
  <div class="page">
    <van-nav-bar title="实习总结" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="header">
      <div class="left">
        <div class="title">{{ pageData.xm }}提交的实习总结</div>
        <div class="info">班级：{{ pageData.bj }}</div>
        <div class="info">学号：{{ pageData.xh }}</div>
      </div>
    </div>
    <!-- 审批意见 -->
    <div class="status-box">
      <div class="status">
        指导教师评阅：
        <p v-if="pageData.pyzt != '3'">{{ pageData.pyjg || '待评阅' }}</p>
        <p v-else>打回</p>
      </div>
      <div class="tip-title" v-if="pageData.pynr != ''">评语：</div>
      <div>{{ pageData.pynr }}</div>
    </div>
    <!-- 日志详细 -->
    <div class="summary-content">
      <div class="title">标题</div>
      <div class="content">
        {{ pageData.bt }}
      </div>
      <div v-if="schoolCode == '14475'"  class="title">实习主要内容及进程</div>
      <div class="content">
        {{ pageData.sxzynrjc }}
      </div>
      <div v-if="schoolCode != '14475'"  class="title">内容</div>
      <div v-else class="title">主要收获和体会</div>
      <div class="content">
        {{ pageData.nr }}
      </div>
      <div v-if="schoolCode == '14475'"  class="title">实习单位对实习工作的建议</div>
      <div class="content">
        {{ pageData.sxgzjy }}
      </div>
      <div v-if="schoolCode == '14475'"  class="title">实习成果</div>
      <div class="content">
        {{ pageData.sxcg }}
      </div>


      <div class="title">图片</div>
      <div class="content">
        <img :src="pageData.fileBase64" alt="" />
      </div>
      <div class="title">位置</div>
      <div class="content">
        {{ pageData.dz }}
      </div>
    </div>
    <div class="button-box" v-if="showEditButton || pageData.pyzt == '3'">
      <div class="button"  @click="edit()">编辑</div>
    </div>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      schoolCode:sessionStorage.getItem("schoolCode"),
      pageIndex: 0,
      pageData: {
        xm: '',
        xh: '',
        bj: '',
        bt: '',
        dz: '',
        jg0101id: '',
        nr: '',
        pydf: '',
        pyfs: '',
        pyjg: '',
        pyjl: '',
        pynr: '',
        pysj: '',
        pyzt: '1',
        sfyc: '0',
        sqzp: '',
        sxjhid: '',
        sxzjid: '',
        tjsj: '',
        xnxq01id: '',
        xs0101id: '',
        yczwtjsj: '',
        ytjsj: '',
        filebase64: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
    }),
    showEditButton(){
      let nowDate = new Date().getTime()
      let lateDate = new Date(this.pageData.yczwtjsj).getTime()
      if(this.pageData.pynr == '' && (nowDate < lateDate)){
        return true
      }
      return false
    }
  },
  methods: {
    edit() {
      this.$router.push({
        path: '/internship/summary',
        query: {
          edit: true,
          data: this.pageData
        }
      })
    },
  },
  async created() {
    if (this.$route.query.sxzjid) {
      const res = await iApi.getSummaryDetail({
        sxzjid: this.$route.query.sxzjid,
      })
      this.pageData = res.data
    }
  },
}
</script>
<style lang="less" scoped>
.page {
  background: #f2f2f4;
  min-height: 100vh;
  padding-bottom: 100px;
  margin-top: -50px;
}

.header {
  padding: 15px;
  height: 70px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;

  .left {
    flex: 1;

    .title {
      width: 250px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #353535;
      line-height: 22px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .info {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }

  img {
    width: 89px;
    height: 70px;
  }
}
.status-box {
  width: 315px;
  // min-height: 158px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .tip-title {
    margin-top: 15px;
    margin-bottom: 6px;
    color: #999999;
  }
  .status {
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    p {
      color: #f85352;
    }
  }
}
.summary-content {
  width: 315px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  margin: 10px auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .title {
    color: #999999;
    margin-bottom: 5px;
  }
  .content {
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      display: block;
      overflow: hidden;
    }
  }
  .edit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-top: 1px solid #e5e5e5;
    i {
      margin-right: 5px;
    }
  }
}

.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/summaryDetail.vue